import { render, staticRenderFns } from "./ObjektiCard2Tab-11-Zalihe.vue?vue&type=template&id=77c6bf5e&scoped=true&"
import script from "./ObjektiCard2Tab-11-Zalihe.vue?vue&type=script&lang=ts&"
export * from "./ObjektiCard2Tab-11-Zalihe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c6bf5e",
  null
  
)

export default component.exports